module.exports = __webpack_public_path__ + "media/images/card-img--f8a4fc856dd7eeddb7abc6fc44a715c9.png";